/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import CloseAction from './CloseAction/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content/Images/Videos/VideosTree/Content/Files/File/DeleteAction/Confirmation/Content"
  
}) {
let constantData = 'Delete '
let videoFileNameValueData = fromData.useDataValue({ viewPath,
context: 'video',
path: 'file_name',
})
let aggregateData = fromAggregate.join(constantData, videoFileNameValueData)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let onClick = fromHelpers.useOnDelete({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 height="auto"
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 data="'Delete '"
 data="video.file_name"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
 text="Delete Capture"
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Are you sure you want to delete this video?"
 marginTop={dtSpaceS}
 marginBottom={dtSpaceS}
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="critical"
 onClick={onClick}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Delete"
/>
)}
</TysiaButton>
</div>
</div>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}